import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentUserAsAvailable } from '@user/shared/current-user';
import { useSharingUrl } from '~/utils/build-sharing-url';
import { useUserDescription, useUserLinkPreviewTitle } from '@user/shared/use-tdk';
import { UserDetailUtil } from 'shared/models';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const UserOG: FC = () => {
  const user = useAtomValue($CurrentUserAsAvailable);

  const title = useUserLinkPreviewTitle();
  const description = useUserDescription();

  const url = useSharingUrl(UserDetailUtil.getPath(user));

  return (
    <DynamicHead>
      <meta property="og:url" content={url} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image" content={user.avatar} />
    </DynamicHead>
  );
};
